module.exports = __webpack_public_path__ + "img/my.c79e8962.png";